import raw from "./cameras.json";
import { normalizeCamera } from "../engine/ruleEngine";

// cameras.json stores `videoModes` as the single source of truth for what
// resolution/frame-rate combinations exist. The flat `resolutions` and
// `frameRates` arrays that the UI wants are derived here rather than
// duplicated in the JSON, where the two copies would drift apart the first
// time a camera is edited.
//
// Import from THIS file, never from cameras.json directly.
const cameras = raw.map(normalizeCamera);

export default cameras;

export const fullSpecCameras = cameras.filter((c) => c.capabilityLevel === "full");
export const exposureOnlyCameras = cameras.filter((c) => c.capabilityLevel === "exposure-only");

export function findCamera(id) {
  return cameras.find((c) => c.id === id);
}
